<template>
  <div
    class="page_container sttingPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/warehousIndex/wManageIndex' }"
          >库存管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{
            path: `/warehousIndex/wManageSettingList`,
          }"
          >明细数据</el-breadcrumb-item
        >
        <el-breadcrumb-item>库存管理设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>入库管理设置</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark"></span>变动原因：</p>
            <div class="select_box">
              <el-select
                v-model="formData.actreasonid"
                placeholder="选择变动原因"
                @focus="getShopBasenumReason"
              >
                <el-option
                  v-for="item in actreasonList"
                  :key="item.reasonid"
                  :label="item.reason"
                  :value="item.reasonid"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库数量：</p>
            <div class="input_box">
              <el-input
                type="number"
                v-model="formData.num"
                placeholder="输入入库数量"
                maxlength="10"
              ></el-input>
            </div>
          </div>
          <!-- <div class="block">
            <p><span class="mark">*</span>入库订单信息记录：</p>
            <div class="input_box">
              <el-input
                type="number"
                v-model="formData.purchaseno"
                placeholder="输入入库订单信息"
                maxlength="50"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库收货物流类型：</p>
            <div class="select_box">
              <el-select
                v-model="formData.wsid"
                placeholder="选择记录入库收货物流类型"
                @focus="handleFocusGetLog"
                :loading="loadingLog"
              >
                <el-option
                  v-for="item in logisiticsList"
                  :key="item.etext"
                  :label="item.evalue"
                  :value="item.etext"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库收货物流单号记录：</p>
            <div class="input_box">
              <el-input
                v-model="formData.wsno"
                placeholder="选择记录入库收货物流单号"
                maxlength="50"
              ></el-input>
            </div>
          </div> -->
          <div class="block">
            <p>备注信息记录：</p>
            <div class="textarea_box">
              <el-input
                type="textarea"
                v-model="formData.reason"
                placeholder="填写备注（200字以内）"
                maxlength="200"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库位置：</p>
            <div class="select_box">
              <el-select
                v-model="formData.whid1"
                placeholder="选择仓库"
                @change="handleChangeWarehouseOne"
              >
                <el-option
                  v-for="item in warehouseOne"
                  :key="item.id"
                  :label="item.whname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.whid2"
                placeholder="选择层号"
                @change="handleChangeWarehouseTwo"
              >
                <el-option
                  v-for="item in warehouseTwo"
                  :key="item.id"
                  :label="item.whname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.whid3"
                placeholder="选择位置"
                @change="handleChangeWarehouseThree"
              >
                <el-option
                  v-for="item in warehouseThree"
                  :key="item.id"
                  :label="item.whname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select v-model="formData.whid4" placeholder="选择位置">
                <el-option
                  v-for="item in warehouseFour"
                  :key="item.id"
                  :label="item.whname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库商品属性参数记录：</p>
            <div
              class="block_item flex-rowl"
              style="margin-bottom: 15px"
              v-for="(item, index) in detail.attr"
              :key="index"
            >
              <span>{{ item.attrname }}：</span>
              <div class="select_box" style="flex: 1">
                <el-select
                  v-model="attrArr[item.attrname]"
                  placeholder="选择属性标签"
                  @change="changeAttr($event, item.attrname, index)"
                >
                  <el-option
                    v-for="itemChild in item.items"
                    :key="itemChild.id"
                    :label="itemChild.attrvalue"
                    :value="itemChild.attrvalue"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <!-- <div class="select_box">
              <el-select
                v-model="formData.ams_shop_commodity_attrid"
                placeholder="选择属性标签"
                @focus="handleFocusGetAttrid"
                :loading="loadingAttrid"
                @change="changeAttr"
              >
                <el-option
                  v-for="item in attrLabelList"
                  :key="item.id"
                  :label="item.attrname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.ams_shop_commodity_attr_value"
                placeholder="选择属性值"
                @focus="handleFocusGetAttrvalue"
                :loading="loadingAttrvalue"
                @change="changeAttrValue"
              >
                <el-option
                  v-for="item in attrValueList"
                  :key="item.id"
                  :label="item.attrvalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div> -->
          </div>

          <div class="block">
            <p><span class="mark">*</span>入库商品批次记录：</p>
            <div class="input_box">
              <el-input
                v-model="formData.makerno"
                placeholder="输入商品批次记录"
              ></el-input>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>入库商品生产商：</p>
            <div class="select_box">
              <el-select
                v-model="formData.makername"
                placeholder="选择商品生产商"
                @focus="handleFocusGetSupplier"
                :loading="loadingSupplier"
              >
                <el-option
                  v-for="item in supplierList"
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="handleSubmit">保存并继续添加</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  setShopWareParam,
  getWearhouseList,
  getProducerList,
  getLogistics,
  getAttrLabelList,
  getAttrLabelValue,
  encryptstringview,
} from "../../api/api";
import { getShopBasenumReason } from "../../api/shop";
export default {
  name: "wManageSettingItem",
  data() {
    return {
      qyid: 0,
      nowDate: "",

      detail: "", // 商品详情

      isShow: false,
      columns: ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华", "衢州"],
      // 记录类型
      actname: "",
      actnameList: [
        {
          text: "增加",
          value: "add",
        },
        {
          text: "减少",
          value: "reduce",
        },
      ],

      warehouseList: [],
      warehouseOne: [], // 仓库
      warehouseTwo: [], // 货架
      warehouseThree: [], // 层数
      warehouseFour: [], // 位置

      // 生产商
      supplierList: [],
      loadingSupplier: false,

      // 物流
      logisiticsList: [],
      loadingLog: false,

      // 属性标签
      attrLabelList: [],
      loadingAttrid: false,
      // 属性值
      attrValueList: [],
      loadingAttrvalue: false,

      // 仓库变动原因
      actreasonList: [],
      actreasonValue: "",

      keyword: "",
      loading: false,
      type: 1, // 1采购入库 2生产入库
      formData: {
        Method: "ams_shop_commodity_basenumadd",
        cmid: "",
        actname: "", // 记录类型 add增加 reduce减少
        actreasonid: "", // 变动原因id 从接口246获取reasonid
        num: "", // 数量
        reason: "", // 备注
        whid1: "", // 接口224仓库id
        whid2: "", // 接口224货架id
        whid3: "", // 接口224层位id
        whid4: "", // 接口224货位id

        userman: "", // 登录的管理员名
        // ams_shop_commodity_attrid: "", // 属性标签id 从接口235获取
        // ams_shop_commodity_attr_value: "", // 属性值id 从接口236获取
        attr: [], // 多组属性标签
        purchaseno: "", // 采购订单号
        wsid: "", // 物流类型 从接口237获取
        wsogid: "", // 物流商品id 默认跟cmid一样
        makerno: "", // 商品批次
        makername: "", // 生厂商id 从接口234的生厂商字段(supplier)里获取
        wsno: "", // 物流单号
      },
      attrName: "", // 商品属性

      attrArr: [],
    };
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.id;
    } else {
      this.qyid = 0;
    }
    this.formData.userman = USERINFO.truename;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { cmid, type, keyword } = JSON.parse(res.jsondata);
        this.keyword = keyword;
        this.formData.cmid = cmid;
        this.formData.wsogid = cmid;
        this.formData.actname = type;
        this.getInit();
      } else {
        this.$router.back();
      }
    },

    async getInit() {
      await this.getDetail();
      await this.getWarehouse();
      // await this.getLogisitics();
      // await this.getAttrLabel();
    },

    // 获取商品详情
    getDetail() {
      let { cmid } = this.formData;
      getCommidityDetail({ id: cmid }).then((res) => {
        this.detail = res;
      });
    },

    // 获取仓库-货架-层号-位置
    getWarehouse() {
      getWearhouseList({
        openid: this.$store.state.OPENID,
        qyid: this.qyid,
      }).then((res) => {
        if (res.length > 0) {
          this.warehouseOne = res;
        } else {
          this.warehouseOne = [];
        }
      });
    },
    handleChangeWarehouseOne(e) {
      let { warehouseOne } = this;
      warehouseOne.forEach((v) => {
        if (v.id == e) {
          this.warehouseTwo = v.childs2;
        }
      });
      this.formData.whid2 = "";
      this.formData.whid3 = "";
      this.warehouseThree = [];
      this.formData.whid4 = "";
      this.warehouseFour = [];
    },
    handleChangeWarehouseTwo(e) {
      let { warehouseTwo } = this;
      warehouseTwo.forEach((v) => {
        if (v.id == e) {
          this.warehouseThree = v.childs3;
        }
      });
      this.formData.whid3 = "";
      this.formData.whid4 = "";
      this.warehouseFour = [];
    },
    handleChangeWarehouseThree(e) {
      let { warehouseThree } = this;
      warehouseThree.forEach((v) => {
        if (v.id == e) {
          this.warehouseFour = v.childs4;
        }
      });
      this.formData.whid4 = "";
    },

    // 获取物流类型
    handleFocusGetLog() {
      this.loadingLog = true;
      getLogistics().then((res) => {
        this.logisiticsList = res;
        this.loadingLog = false;
      });
    },
    // 获取属性标签
    handleFocusGetAttrid() {
      this.loadingAttrid = true;
      getAttrLabelList().then((res) => {
        let newArr = [
          {
            attrname: "无",
            id: 0,
          },
        ];
        let filterArr = res.filter((v) => v.attrstate == "启用");
        this.attrLabelList = newArr.concat(filterArr);
        this.loadingAttrid = false;
        this.formData.ams_shop_commodity_attr_value = "";
      });
    },
    changeAttr(e, attrname, index) {
      // 更新保存下拉选项值的对象
      this.formData.attr[index] = attrname + "；" + e;
      this.attrArr[attrname] = e;
      console.log(this.formData.attr, index, "----");
    },
    // changeAttrValue(e) {
    //   let { attrValueList, attrName } = this;
    //   attrValueList.forEach((v) => {
    //     if (e == v.id) {
    //       this.formData.attr = JSON.stringify([attrName + "；" + v.attrvalue]);
    //     }
    //   });
    // },
    // 获取属性值
    handleFocusGetAttrvalue() {
      let { ams_shop_commodity_attrid, cmid } = this.formData;
      this.loadingAttrvalue = true;
      getAttrLabelValue({ cmid, attrid: ams_shop_commodity_attrid }).then(
        (res) => {
          let newArr = [
            {
              attrvalue: "无",
              id: 0,
            },
          ];
          let filterArr = res.filter((v) => v.isuse);
          this.attrValueList = newArr.concat(filterArr);
          this.loadingAttrvalue = false;
        }
      );
    },
    // 获取生产商
    handleFocusGetSupplier() {
      let { qyid } = this;
      this.loadingSupplier = true;
      getProducerList({ qyid, Page: 1, PageSize: 100 }).then((res) => {
        this.supplierList = res;
        this.loadingSupplier = false;
      });
    },
    // 获取仓库变动原因
    getShopBasenumReason() {
      let type = this.formData.actname;
      getShopBasenumReason().then((res) => {
        // reasontype - add、reduce
        let filterArr = res.filter((v) => v.reasontype === type);
        this.actreasonList = filterArr;
      });
    },

    handleReturn() {
      // history.back();
      this.$router.push({ name: "wManageSettingList" });
    },

    handleSubmit() {
      let { formData, detail } = this;
      if (formData.num == "") {
        this.$message.warning("请输入入库数量");
        return;
      }
      if (formData.attr.length < detail.attr.length) {
        this.$message.warning("请选择全部属性标签值");
        return;
      }

      // if (formData.ams_shop_commodity_attrid == "") {
      //   this.$message.warning("请选择属性标签");
      //   return;
      // }
      // if (formData.ams_shop_commodity_attr_value == "") {
      //   this.$message.warning("请选择属性值");
      //   return;
      // }
      // if (formData.purchaseno == "") {
      //   this.$message.warning("请输入入库订单信息");
      //   return;
      // }
      // if (formData.wsno == "") {
      //   this.$message.warning("请输入入库收货物流单号");
      //   return;
      // }
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let h = time.getHours();
      let m = time.getMinutes();
      let s = time.getSeconds();
      this.nowDate =
        year + "-" + month + "-" + date + " " + h + ":" + m + ":" + s;
      this.loading = true;
      // if (formData.ams_shop_commodity_attrid == 0) {
      //   this.formData.ams_shop_commodity_attrid = "";
      //   this.formData.ams_shop_commodity_attr_value = "";
      //   this.formData.attr = "";
      // }
      formData.attr = JSON.stringify(formData.attr);
      setShopWareParam(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          setTimeout(() => {
            // message.close();
            // history.back();
            this.initData()
          }, 700);
        } else {
          this.loading = false;
          this.$message.error(res.message);
        }
      });
    },

    // 初始化数据
    initData() {
      this.formData.actreasonid = ''
      this.formData.num = ''
      this.formData.reason = ''
      this.formData.whid1 = ''
      this.formData.whid2 = ''
      this.formData.whid3 = ''
      this.formData.whid4 = ''
      this.formData.attr = []
      this.formData.purchaseno = ''
      this.formData.wsid = ''
      this.formData.makerno = ''
      this.formData.makername = ''
      this.formData.wsno = ''
      this.attrArr = []
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .form_footer {
    .btn {
      width: auto;
      padding: 0 20px;
    }
  }
}
</style>